import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorefrontContextService } from '../services/storefront-context.service';
import { StorefrontSessionService } from '../services/storefront-session.service';

export const storefrontCustomerGuard: CanActivateFn = () => {
  const session = inject(StorefrontSessionService);
  const router  = inject(Router);
  const ctx     = inject(StorefrontContextService);
  const companyId = ctx.companyId();
  if (companyId && session.getAuth(companyId)) return true;
  return router.createUrlTree(ctx.storeLink('login'));
};
